// extracted by mini-css-extract-plugin
module.exports = {"cardHit":"searchResultsHitMobile_cardHit__VZU34"};